import { render, staticRenderFns } from "./salepartsetting.vue?vue&type=template&id=3578df54&scoped=true&"
import script from "./salepartsetting.vue?vue&type=script&lang=js&"
export * from "./salepartsetting.vue?vue&type=script&lang=js&"
import style0 from "./salepartsetting.vue?vue&type=style&index=0&id=3578df54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578df54",
  null
  
)

export default component.exports